module.exports = __webpack_public_path__ + "img/file-type-code.4f48eeaf.svg";